export default "__VITE_ASSET__C9B8$IwT__"